<template>
    <div class="members">
        <List v-if="client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <component v-if="component" :is="component" :item="item" @emit="emit" />
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import WebSoc from '../utils/WebSoc.js';
import CustomerStats from '../components/CustomerStats.vue';
import Stamps from '../components/Stamps.vue';
import EditMember from '../components/editMember.vue';

export default {
    name: 'members',
    components: {
        List,
        Stamps,
        EditMember,
        CustomerStats
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    created () {
        this.list.dbClient_id = this.client_id; 
        this.list.filter.client_id = this.client_id;       
    },
    data () {
        return {
            component: '',
            item: false,
            list: { 
                t: 'customer-list',
                DB: 'customers',
                dbClient_id: '',
                storeDB: true,
                title: 'Members',
                fields: [
                    { title: 'Status', field: 'closed', width: 200, 
                            map: item => 
                            item.closed > 0 ? 
                                ( 'CLOSED '+format(item.closed,'dd/MM/yy') ) 
                                : 
                                (`ACTIVE${item.demo ? '<span class="demo"></span>' : ''}${item.staff ? '<span class="staff"></span>' : ''}${item.manager ? '<span class="manager"></span>' : ''}` ) },
                    { title: 'Joined', field: 'joined', class: 'ta-r', width: 120, order: 'asc', map: item => format(item.joined,'dd/MM/yy'), type: 'date' },
                    { title: 'Name', field: 'name', class: 'td-ulb', width: '1fr', map: item => (item.sendSMS === false ? '<span class="no-sms"></span>' : '') + (item.sendEMAIL === false ? '<span class="no-email"></span>' : '') + item.name  },
                    { title: 'Member #', field: 'customerNo', width: 110, type: 'num' },
                    { title: 'Mobile', field: 'phone', width: '1fr', map: item => item.phone && prettyPhone(item.phone) },
                    { title: 'Email', field: 'email', width: '1fr' },
                    { title: 'Sent', field: 'sent', width: 90, class: 'ta-r', type: 'num' },
                    { title: 'Visits', field: 'landed', width: 90, class: 'ta-r', type: 'num' },
                    { title: 'Opens', field: 'opens', width: 90, class: 'ta-r ', type: 'num'},
                    { title: 'Offers', field: 'ads', width: 90, class: 'ta-r td-ulb', type: 'array' ,map: item => (item.ads || []).filter(ad => !ad.dateRedeemed).length },
                    { title: 'Stamps', field: 'stampQty', width: 90, class: 'ta-r td-ulb', type: 'num' },
                    { title: 'Redeems', field: 'redeemCount', width: 100, class: 'ta-r td-ulb', type: 'num', map: item => item.redeemCount > 0 ? item.redeemCount : '' },
                    { title: 'Last Activity', field: 'active', width: 160, class: 'ta-r', type: 'date', map: item => item.active > 0 ? format(item.active,'dd/MM/yy HH:mm') : '' }
                ],
                filter: { staff: { $ne: true }, demo: { $ne: true } },
                project: { sendSMS: 1, sendEMAIL: 1, manager: 1, staff: 1, demo: 1 },
                onItemsXX ( items ) {
                    var campaign_id = "5f8424803b944d20b9954c54" // COCKTAIL & FIZZ POINTS;
                    var client_id = this.filter.client_id;
                    var db = client_id+'-customers';
                    //console.log('Members',db);
                    //console.log('onItems',JSON.parse(JSON.stringify(items)));

                    return;
                    /*
                    JSON.parse(JSON.stringify(items)).forEach(customer => {
                        WebSoc.SEND('update',{ DB: db, _id: customer._id, update: { $set: { [campaign_id]: customer.loyaltyQty || 0 } }},resp => {
                            console.log('updated customer');
                        });                      
                    });
                    */
                }
            } 
        }
    },
    methods: {
        newMember () {
            console.log('new Member ?');
        },
        'customer-list' ({ action, field, item, value, e }) {

            if ( action == 'new' ) return this.newMember();

            switch ( field.field ) {
                case 'closed':
                    if ( item.components.length == 1 ) {
                        item.components.pop()
                    } else {
                        item.components.push('memberDetail');
                    }
                return;
                case 'name':
                    WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id: item._id },customer => {
                        this.item = customer;
                        this.component = 'EditMember';
                        //console.log('customer',customer);
                    });
                    break;
                case 'ads':
                case 'redeemCount':
                case 'stampQty':
                    WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id: item._id },customer => {
                        WebSoc.SEND('search',{ DB: 'users', find: { 'loyaltyAwards.customer_id': item._id }},users => {
                            console.log('users',users);
                            users.forEach(user => {
                                user.loyaltyAwards = user.loyaltyAwards.filter(a => a.customer_id == item._id);
                            });
                            var awards = users.reduce((p,user) => {
                                return p.concat(user.loyaltyAwards.map(a => { console.log('a',a); return { name: user.name, date: a.now > 0 ? format(a.now,'dd/MM/yy HH:mm') : '', qty: a.qty } }))
                            },[]);
                            customer.awards = awards;
                            this.item = customer;
                            this.component = 'CustomerStats'
                        })
                    });                 
                    break;
                default:
                    console.log('customer-list',{
                        e, 
                        field,
                        item,
                        value
                    });
            }

        },
        'edit-member' ({ action, field, value, item, e }) {
            switch ( action ) {
                case 'exit':
                    this.component = '';
                    this.item = false;
                    return;
                break;    
            }

        },
        emit ( data ) {
            console.log('Members emit data',data);
            if ( data.action == 'exit' ) {
                this.component = '';
                this.item = false;
                data.item && Array.isArray(data.item.components) && data.item.components.pop();
            }

            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('what emmit');
        },
    }
}    
</script>

<style scopped lang="scss">
.no-sms::before {
    margin-top: 2px;
}
.members {
    .manager,.staff,.demo {
        padding: 3px 3px 3px 3px;
        margin: 0px 3px;
        border: 1px solid grey;
        width: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
        float: right;
        position: relative;
    }
    .manager:after {
        content: 'm'
    }
    .staff:after {
        content: 's'
    }
    .demo:after {
        content: 'd'
    }
}
</style>